const DATA_ROOT = `${process.env.PUBLIC_URL || ''}/location-data`;

let provincesPromise = null;
let districtsPromise = null;
const settlementsCache = new Map();

export function normalizeLocationText(value) {
  return String(value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/ı/g, 'i')
    .replace(/İ/g, 'i')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ü/g, 'u')
    .replace(/\s+/g, ' ')
    .trim();
}

async function loadJson(path) {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error('Konum verileri yüklenemedi.');
  }
  return response.json();
}

export function loadProvinces() {
  if (!provincesPromise) {
    provincesPromise = loadJson(`${DATA_ROOT}/provinces.json`);
  }
  return provincesPromise;
}

export function loadDistricts() {
  if (!districtsPromise) {
    districtsPromise = loadJson(`${DATA_ROOT}/districts.json`);
  }
  return districtsPromise;
}

export function loadProvinceSettlements(provinceId) {
  if (!provinceId) return Promise.resolve([]);
  const key = String(provinceId);
  if (!settlementsCache.has(key)) {
    settlementsCache.set(key, loadJson(`${DATA_ROOT}/settlements/${key}.json`));
  }
  return settlementsCache.get(key);
}

export function searchItems(items, query, fields = ['name', 'label']) {
  const normalizedQuery = normalizeLocationText(query);
  if (!normalizedQuery) return items.slice(0, 80);
  return items
    .filter((item) => fields.some((field) => normalizeLocationText(item[field]).includes(normalizedQuery)))
    .slice(0, 80);
}
